module.exports = __webpack_public_path__ + "Roboto-RegularItalic.527502d7927a41ca0b6a.svg";


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/roboto-fontface/fonts/Roboto/Roboto-RegularItalic.svg
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-RegularItalic.svg
// module chunks = 34